// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Card, Segment, Image, Icon, Grid, Loader, Dimmer } from 'semantic-ui-react'
import ScrollArea from '@xico2k/react-scroll-area'

import SingleRow from './SingleRow'

export default class ManageSheet extends Component {
  constructor (props) {
    super(props)
    this.state = {
      components: [],
      rows: [],
      loading: true
    }
  }

  componentDidMount = () => {
    this.sheetData()
  }

  sheetData = (e) => {
    this.setState({
      loading: true
    })
    window.scrollTo(0, 0)
    fetch('https://murkstomstag.herokuapp.com/api/v1/sheet/data', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sheetID: this.props.sheetID,
        userUnderscore: this.props.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if ((json.code = 200)) {
          this.setState(
            {
              selectedValue1: json.selectedValue1,
              selectedValue2: json.selectedValue2,
              selectedValue3: json.selectedValue3,
              selectedImage: json.selectedImage,
              theme: json.theme,
              active: true,
              done: true,
              loading: false
            },
            () => {
              this.sheet()
            }
          )
        } else {
          this.setState({
            loading: false,
            error: json.code
          })
        }
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false })
      })
  }

  sheet = () => {
    this.setState({
      loading: true
    })
    var self = this
    var request = new Request('https://sheetjson.herokuapp.com/api?id=' + self.props.sheetID)
    fetch(request)
      .then(function (result) {
        return result.json()
      })
      .then(function (result) {
        var rows = []
        var columns = []
        for (let column in result.columns) {
          columns.push({
            value: column,
            text: column,
            key: column
          })
        }
        var dataR = result.rows
        for (let row in dataR) {
          var value = dataR[row]
          rows.push({ value })
        }
        console.log('sheet 200 ok ')

        self.setState({
          columnsLength: Object.keys(result.columns).length,
          rowsLength: Object.keys(result.rows).length,
          columns: columns,
          rows: rows,
          loading: false
        })
        self.sheetComponents()
      })
      .catch(function (err) {
        console.log(err)
      })
  }

  sheetComponents = (e) => {
    this.setState({
      loading: true
    })
    fetch('https://murkstomstag.herokuapp.com/api/v1/sheet/components', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sheetID: this.props.sheetID,
        userUnderscore: this.props.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        if ((json.code = 200)) {
          console.log('sheetComponents 200 ok')

          this.setState({
            components: json.components,
            componentsIndex: json.componentsIndex,
            loading: false,
            active: true,
            done: true,
            singleRow: false
          })
        } else {
          this.setState({
            loading: false,
            error: json.code
          })
        }
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false })
      })
  }

  goBack = (e) => {
    this.props.goBack()
    this.setState({ done: true, singleRow: false, selectedIndex: null })
  }

  singleRow = (index, item, e) => {
    try {
      this.props.singleRow()
    } catch (error) {
      console.error(error)
    }

    this.setState({
      done: false,
      singleRow: true,
      index: item.value
    })
  }

  render () {
    let {
      loading,
      selectedImage,
      theme,
      copied,
      error,
      done,
      singleRow,
      selectedValue1,
      selectedValue2,
      selectedValue3
    } = this.state

    const rows = this.state.rows.map((item, index) => (
      <Card
        inverted='true'
        style={{ overflow: 'hidden' }}
        link
        key={index}
        onClick={() => this.singleRow(index, item)}>
        {selectedImage && theme === 'wrap' && (
          <Image wrapped ui={false} src={item.value[selectedImage]} />
        )}
        <Card.Content>
          {selectedImage && theme === 'float' && (
            <Image floated='right' size='mini' src={item.value[selectedImage]} />
          )}
          <Card.Header>{item.value[selectedValue1]}</Card.Header>
          <Card.Description>{item.value[selectedValue2]}</Card.Description>
        </Card.Content>
        <Card.Content extra>{item.value[selectedValue3]}</Card.Content>
      </Card>
    ))

    return (
      <div className='mb'>
        {loading && (
          <div className='mt'>
            <Loader indeterminate size='small' inline='centered' active />
          </div>
        )}
        <div style={{ position: 'fixed', zIndex: 999999 }}>
          <Grid verticalAlign='middle'>
            <Grid.Column width='8' floated='left' className='cursor'>
              {singleRow && !loading && !error && !done && (
                <div style={{ marginLeft: 14 }} className='cursor'>
                  <Icon name='angle left' size='large' onClick={this.goBack} />
                </div>
              )}
            </Grid.Column>
            {copied && (
              <Grid.Column width='8' textAlign='right'>
                <div style={{ marginRight: 14 }}>
                  <Icon name='copy' size='large' />
                </div>
              </Grid.Column>
            )}
          </Grid>
        </div>

        {error && (
          <Segment padded style={{ margin: 14 }} className='mtb'>
            <h3>OOPS!</h3>
            <h5>
              <b>Error: {error}</b>
            </h5>
          </Segment>
        )}
        {done && !singleRow && !loading && (
          <div style={{ backgroundColor: 'transparent' }}>
            <ScrollArea trackHidden height='590px'>
              <Card.Group style={{ padding: 14 }}>{rows}</Card.Group>
            </ScrollArea>
          </div>
        )}
        {singleRow && !done && !loading && (
          <div style={{ backgroundColor: 'transparent' }}>
            <div style={{ height: '30px' }} />
            <SingleRow {...this.state} />
          </div>
        )}
      </div>
    )
  }
}
